// * Created by edwardwieczorek on 8/6/15.
//===============================

//This is the default entry file for the US Netting Project
//This entry file is specified for any default page setting
//Use this if a page does not have specific functionality
//include calculator
//Contains Foundation, JQuery, SmoothScrolling Functionality
// was modernizr
import $ from "jquery";
import 'bootstrap';
import './pages/main.js';
//Main General Calculator Script
import './plugins/validate.js';
import './utils/calculator.js';

import './plugins/jquery.zoom.js';
import './plugins/flexslider.js';
import TweenMax from 'gsap';
import './pages/gym-curtains.js';



// WEBPACK FOOTER //
// ./gymcurtains.js